export var TAPSocketReservedEvents;
(function (TAPSocketReservedEvents) {
    TAPSocketReservedEvents["CONNECT"] = "connect";
    TAPSocketReservedEvents["DISCONNECT"] = "disconnect";
    TAPSocketReservedEvents["CONNECT_ERROR"] = "connect_error";
    TAPSocketReservedEvents["RECONNECT"] = "reconnect";
    TAPSocketReservedEvents["SUBSCRIBE_TOPICS"] = "subscribeTopics";
    TAPSocketReservedEvents["UNSUBSCRIBE_TOPICS"] = "unsubscribeTopics";
})(TAPSocketReservedEvents || (TAPSocketReservedEvents = {}));
//# sourceMappingURL=events.type.js.map